import React, { useState, useEffect } from 'react';
import { Grid, FormControl, TextField, InputLabel, Select, MenuItem, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    error: { '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red',
    } },

  };
});

const SelectAux = (
  {
    value,
    onChange,
    options,
    disabledValue,
    style,
    error,
    className = '',
    disabled = false,
    ...rest
  },
) => {
  const classes = useStyles();

  return (
    <FormControl fullWidth size='small' { ...rest }>
      <Select
        { ...rest }
        size='small'
        className={ error ? classes.error : className }
        fullWidth
        variant='outlined'
        color='secondary'
        disabled={ disabled }
        value={ value || disabledValue }
        style={ { ...style } }
        onChange={ (event) => {
          return onChange(event.target.value);
        } }
      >
        <MenuItem disabled value={ disabledValue }>
          <Typography component='div' variant='subtitle2'>
            { disabledValue }
          </Typography>
        </MenuItem>
        {
          options.map((option) => {
            return (
              <MenuItem key={ option } value={ option }>
                <Typography component='div' variant='subtitle2'>
                  { option }
                </Typography>
              </MenuItem>
            );
          })
        }

      </Select>
    </FormControl>
  );
};

const linear = (from, to, inclusiveRight = true) => {
  return Array.from(Array(to - from + (inclusiveRight ? 1 : 0)).keys())
    .map((n) => { return n + from; });
};

const currentYear = (new Date()).getFullYear();
const years = linear(currentYear - 1, currentYear + 1)
  .map((year) => {
    return year.toString();
  })
  .reverse();

const SimpleDateField = (
  {
    label,
    required,
    defaultValue,
    error,
    name,
    style = {},
    className = '',
    validate = null,
    disabled = false,
    country = 'GR',
    onChange = null,
  },
) => {
  const [ value, setValue ] = useState(defaultValue);

  const getDays = (_month) => {
    return linear(1, 31)
      .map((day) => {
        return day.toString()
          .padStart(2, '0');
      });
  };

  const getMonths = (_day) => {
    return linear(1, 12)
      .map((month) => {
        return month.toString()
          .padStart(2, '0');
      });
  };

  const [ days, _setDays ] = useState(getDays());

  const [ months, _setMonth ] = useState(getMonths());

  useEffect(() => {
    setValue(defaultValue);
  }, [ defaultValue ]);

  const [ yyyy, mm, dd ] = value.split('-');

  useEffect(() => {
    setValue(`${ yyyy }-${ mm }-${ dd }`);
  }, [ setValue ]);

  const handleDateChange = (v) => {
    console.log('handle called');
    const { day, month, year } = { ...{ day: dd, month: mm, year: yyyy }, ...v };
    const newDate = `${ year }-${ month }-${ day }`;
    setValue(newDate);
    if (null != onChange) {
      onChange(newDate);
    }

    if (error && null !== validate) {
      validate(newDate);
    }
  };

  return (
    <div>
      <TextField
        name={ name }
        type='date'
        value={ value }
        className={ className }
        style={ {
          display: 'none',
          visibility: 'hidden',
          width: 0,
          height: 0,
          overflow: 'hidden',
          ...style,

        } }
      />
      <FormControl
        style={ { lineHeight: 0, marginTop: '18px' } }
        size='small'
        fullWidth
        error={ error }
      >
        <InputLabel
          color='secondary'
          disabled={ disabled }
          shrink
          style={ { fontSize: '16px', fontWeight: 500, transform: 'translate(0px, -18px) scale(1)' } }
          id={ `${ name }-label` }
          htmlFor={ `${ name }-input` }
        >
          { `${ label }${ required ? ' *' : '' }` }
        </InputLabel>
      </FormControl>
      <Grid
        container
        spacing={ 1 }
        style={ { gap: '5px', marginTop: '3px', flexWrap: 'nowrap' } }
        id={ `${ name }-input` }
        aria-labelledby={ `${ name }-label` }
      >
        {
          'US' === country ? (
            <>
              <div style={ { width: '80px' } }>
                <SelectAux
                  disabledValue='mm'
                  error={ error }
                  options={ months }
                  className={ className }
                  style={ { ...style } }
                  onChange={ (v) => {
                    handleDateChange({ month: v });
                  } }
                  value={ mm }
                />
              </div>

              <div style={ { width: '80px' } }>
                <SelectAux
                  disabledValue='dd'
                  options={ days }
                  error={ error }
                  className={ className }
                  disabled={ disabled }
                  onChange={ (v) => {
                    handleDateChange({ day: v });
                  } }
                  style={ { ...style } }
                  value={ dd }
                />
              </div>
            </>
          ) : (
            <>
              <div style={ { width: '80px' } }>
                <SelectAux
                  disabledValue='dd'
                  options={ days }
                  error={ error }
                  disabled={ disabled }
                  className={ className }
                  onChange={ (v) => {
                    handleDateChange({ day: v });
                  } }
                  style={ { ...style } }
                  value={ dd }
                />
              </div>
              <div style={ { width: '80px' } }>
                <SelectAux
                  disabledValue='mm'
                  error={ error }
                  options={ months }
                  disabled={ disabled }
                  className={ className }
                  style={ { ...style } }
                  onChange={ (v) => {
                    handleDateChange({ month: v });
                  } }
                  value={ mm }
                />
              </div>
            </>
          )
        }

        <div style={ { width: '100px' } }>
          <SelectAux
            disabledValue='yyyy'
            disabled={ disabled }
            error={ error }
            className={ className }
            options={ years }
            style={ { ...style } }
            onChange={ (v) => {
              handleDateChange({ year: v });
            } }
            value={ yyyy }
          />
        </div>
      </Grid>
    </div>
  );
};

export default SimpleDateField;
